// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__22hja","colMin":"styles_colMin__2fEy7","colCheckbox":"styles_colCheckbox__2oWx9"};